import styled from 'styled-components';
import colors from "assets/styles/colors";

export default styled.div`
    .sectionTitle {
        font-size: 25px;
        letter-spacing: 0.1em;

        color: ${(props) => props.theme.pageTitleText};
        margin-bottom: 10px;
        margin-top: 20px;
    }

    .inputTitle {
        font-size: 18px;
        letter-spacing: 0.1em;

        color: ${(props) => props.theme.pageTitleText};
        margin-bottom: 5px;
        margin-top: 30px;
    }

    .textFieldDiv {
        width: 300px;
        margin-top: 10px;
    }

    .inputContainerDiv {
    }

    .inputLabel {
        margin-bottom: 10px;
    }

    label {
        letter-spacing: 0.1em;
        color: ${colors.textNavy};
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .selectContainer { 
        flex-direction: row;
        display: inline-block;
    }

    .select {
        width: 300px;
        display: inline;
        float: left;
    }

    .createBtn {
        margin-top: 20px;
        float: right;
    }

    .noData {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 250px;

        svg {
            font-size: 50px;
            color: ${(props) => props.theme.tableHeadCellBackground};
            margin-bottom: 20px;
        }

        .spinner {
            animation: spin 2s linear infinite;
        }

        p {
            color: ${(props) => props.theme.tableHeadCellBackground};
            letter-spacing: 0.1em;
        }
    }

    .blankDiv {
        align-items: center;
        max-width: 250px;
        min-width: 250px;
        height: 40px;
        display: flex;


        cursor: pointer;

        background-color: ${(props) => props.theme.filterButtonBackground};
        color: ${(props) => props.theme.filterButtonForeground};

        border-radius: 5px;
        overflow: hidden;
        
    }

    .iframeContainer {
        padding-top: 20px;
        height: 85vh;
        max-height: 100vh;
    }
`;